export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center hover:opacity-90 transition-opacity">
              <img 
                alt="InstaVisible Tax & Savings Solutions Logo" 
                className="h-14 w-auto object-contain" 
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/e200ded0512fa4f1c42cf2a76268a351.webp"
              />
            </a>
            <a href="/" className="inline-flex items-center cursor-pointer justify-center gap-2 whitespace-nowrap rounded-lg text-sm transition-all h-9 px-4 py-2 bg-emerald-600 text-white hover:bg-emerald-700 font-medium">
              Back to Home
            </a>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-32 pb-24 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Terms and Conditions of Use</h1>
            <p className="text-lg text-gray-600">Last Updated: September 11, 2025</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gray-50 border-l-4 border-emerald-600 p-6 mb-8 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                <strong>THIS IS A LEGAL AGREEMENT BETWEEN YOU AND THE BUSINESS.</strong> You acknowledge that this Agreement is a contract between you and The Business, even though it is electronic and is not physically signed by you. BY ACCESSING AND USING THE PLATFORM, WEBSITE, PRODUCTS AND SERVICES YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THE TERMS OF THIS POLICY.
              </p>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Acknowledgement</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The information provided when using the Platform, Website, Products and Services is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">You represent and warrant that:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>You are not located in a country that is subject to a United States government embargo</li>
              <li>You are not in a country designated by the United States government as a "terrorist supporting" country</li>
              <li>You are not listed on any United States government list of prohibited or restricted parties</li>
              <li>You will not access the Platform through automated or non-human means</li>
              <li>Your use will not violate any applicable law or regulation</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">1. Definitions</h2>
            
            <div className="space-y-4 mb-8">
              <div>
                <strong className="text-gray-900">1.1. "Agreement"</strong>
                <p className="text-gray-700 ml-4">means these terms and conditions of this document and those obligations applicable to User's use of the Platform, Website, Products, and Services, including: Privacy Policy, Disclaimers, User Content Policies, User Contact Policies, Refund Policy, Cookie Policy, DMCA Policy, Accessibility Statement, Shipping Policy, and Affiliate Agreement (if applicable).</p>
              </div>

              <div>
                <strong className="text-gray-900">1.2. "Account"</strong>
                <p className="text-gray-700 ml-4">means any account(s) of or relating to the User for use of the Platform, Website, Products, or Services.</p>
              </div>

              <div>
                <strong className="text-gray-900">1.3. "The Business"</strong>
                <p className="text-gray-700 ml-4">means the entity described at the bottom of the page, having its registered business address at address at the bottom of the page, and includes its subsidiaries and affiliate businesses.</p>
              </div>

              <div>
                <strong className="text-gray-900">1.4. "Products"</strong>
                <p className="text-gray-700 ml-4">means the software, related software products, digital products, other intangible items and tangible physical items of The Business, provided on the Platform and Website or otherwise.</p>
              </div>

              <div>
                <strong className="text-gray-900">1.5. "Services"</strong>
                <p className="text-gray-700 ml-4">means any type of services rendered by The Business, whether related to Products or not, provided by The Business on the Platform, Website or otherwise.</p>
              </div>

              <div>
                <strong className="text-gray-900">1.6. "User"</strong>
                <p className="text-gray-700 ml-4">means all persons accessing or using the Platform, Website, Products, and Services, whether they are a natural or legal person, and all such persons are bound by this Agreement.</p>
              </div>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">2. Accounts and Membership</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>You must be at least 18 years old to use the Platform, Website, Products and Services</li>
              <li>You are responsible for safeguarding your password and for any activities performed using your password</li>
              <li>You agree not to disclose your password to any third party</li>
              <li>You must provide accurate, complete, and current information at all times</li>
              <li>We may suspend, disable, or delete your Account without prior notice for any reason</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">3. User Content</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You are responsible for the Content that you post to the Platform, Website, including its legality, reliability, and appropriateness. You own any Content you submit, but you grant The Business an irrevocable, fully sub-licensable, royalty free, world-wide, perpetual right and license to use, publicly perform, reproduce, adapt, modify, and distribute the Content.
            </p>

            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Prohibited Content</h3>
            <p className="text-gray-700 leading-relaxed mb-4">You may not transmit any Content that is:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>False or misleading information</li>
              <li>Unlawful or promoting unlawful activity</li>
              <li>Defamatory, discriminatory, or mean-spirited</li>
              <li>Spam or unauthorized advertising</li>
              <li>Contains viruses, malware, or other harmful code</li>
              <li>Infringes on intellectual property rights</li>
              <li>Violates the privacy of any third person</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">4. Billing and Payments</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You shall pay all fees or charges to your account in accordance with the fees, charges, and billing terms in effect at the time a fee or charge is due and payable. Payment data is handled and stored by our third-party processors including Stripe and PayPal.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">5. Intellectual Property Rights</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              All content on the Platform, Website, Products and Services is the sole and absolute property of The Business and is protected by intellectual property laws. This Agreement does not transfer any Intellectual Property rights to User. All trademarks, service marks, logos, and other proprietary rights are trademarks or registered trademarks of The Business or its licensors.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">6. License for Use</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We give you a revocable, personal, worldwide, royalty-free, non-assignable and non-exclusive license to use the Website, Products and Services. User agrees not to copy, modify, publish, distribute, reproduce, or infringe in any way any part of the Platform without prior written consent.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">7. Disclaimers</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mb-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                <strong>THE PLATFORM, WEBSITE, PRODUCTS, SERVICES, AND ALL INFORMATION ARE PROVIDED "AS IS" AND "AS AVAILABLE" AT YOUR SOLE RISK AND WITH ALL FAULTS AND DEFECTS WITHOUT WARRANTY OF ANY KIND.</strong> The Business disclaims any and all representations and warranties of any kind, whether express, implied, statutory, or otherwise, including any implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
              </p>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">8. Limitation on Liability</h2>
            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>YOU AGREE TO INDEMNIFY AND HOLD THE BUSINESS HARMLESS FROM ANY LIABILITIES, LOSSES, DAMAGES, OR COSTS, INCLUDING REASONABLE ATTORNEYS' FEES, INCURRED IN CONNECTION WITH ANY THIRD PARTY CLAIMS ARISING FROM:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Your acts or omissions</li>
                <li>Your use of the Website, Products and Services</li>
                <li>Any breach of this Agreement</li>
                <li>Any infringement of intellectual property rights</li>
              </ul>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">9. Dispute Resolution</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Agreement shall be governed by the substantive and procedural laws of the jurisdiction where The Business has its place of business. All disputes shall be settled in accordance with the Rules of Arbitration of the International Chamber of Commerce.
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mt-6">
              <p className="text-gray-700 font-semibold">
                BY AGREEING TO THIS AGREEMENT, USER WAIVES USER'S RIGHT TO PARTICIPATE IN ANY CLASS ACTION, COLLECTIVE ACTION, OR REPRESENTATIVE ACTION. ALL CLAIMS MUST BE BROUGHT ON AN INDIVIDUAL BASIS.
              </p>
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">10. Term and Termination</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Agreement shall remain in full force and effect while you use the Platform, Website, Products and Services. We reserve the right to deny access to and use of the Platform, Website, Products and Services without notice for any reason or no reason, including breach of this Agreement.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">11. Changes and Amendments</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Business reserves the right to modify this Agreement at any time. We will alert you about any changes by updating the "Last Updated" date. Your continued use of the Platform, Website, Products or Services after the effective date of the revised Agreement will constitute your acceptance of those changes.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">12. Contact Information</h2>
            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-6 mt-6">
              <p className="text-gray-700 mb-2"><strong>Business Name:</strong> InstaVisible Tax & Savings Solutions</p>
              <p className="text-gray-700 mb-2"><strong>Email:</strong> contact@instavisible.com</p>
              <p className="text-gray-700"><strong>Website:</strong> www.instavisible.com</p>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                Copyright © 2025 Compliance Media LLC. Licensed to ESTAGE LLC. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-emerald-600">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <p className="text-white/80">© 2025 InstaVisible Tax & Savings Solutions. All rights reserved.</p>
            <div className="flex items-center gap-6 sm:gap-8 text-white/80 flex-wrap justify-center">
              <a href="/privacy-policy" className="hover:text-white transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="/terms-of-use" className="hover:text-white transition-colors whitespace-nowrap">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
